import React from 'react';
import './TabSelector.scss';
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import {Modal, ModalActions} from "./Modal";
import {Button} from './Button';


interface AlertDialogProps {
    open: boolean;
    onClose: () => void;
    title: string;
    contentText: string;
    onClickDismissButton: () => void;
    onClickActionButtonLabel: () => void;
    dismissButtonLabel: string;
    actionButtonLabel: string;
}

const AlertDialog: React.FC<AlertDialogProps> = ({
                                                     open, onClose, title, contentText, onClickDismissButton,
                                                     onClickActionButtonLabel, dismissButtonLabel, actionButtonLabel
                                                 }) => {

    return (
        <Modal isOpen={open} onClose={onClose} title={title}>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">{contentText}</DialogContentText>
            </DialogContent>

            <ModalActions>
                <Button
                    onClick={onClickDismissButton}
                    variant="outlined"
                    color="primary"
                >
                    {dismissButtonLabel}
                </Button>
                <Button
                    onClick={onClickActionButtonLabel}
                    variant="contained"
                    color="attention"
                >
                    {actionButtonLabel}
                </Button>
            </ModalActions>
        </Modal>
    );
}

export default AlertDialog;